import SidebarNavSection from './sidebar_nav_section';

const SidebarNav = ({ items }) => {
  return (
    <ul className="sidebar-nav">
      {items &&
        items.map((item) => (
          <SidebarNavSection
            key={item.title}
            pages={item.pages}
            title={item.showTitle && item.title}
          />
        ))}
    </ul>
  );
};

export default SidebarNav;
